/* eslint-disable */

// The terra FlyoutCartComponent renders the CreditsTracker when a line item
// is flagged as a credit product (`creditProduct: true`) and supplies
// `min` / `max` / `increment` props for the stepper. The /carts API exposes
// the equivalent values on each line item under different names
// (`cartLineItemCategory`, `minPurchaseThreshold`, `maxPurchaseThreshold`,
// `quantityMultiplier`), so this helper performs that mapping in one place.
//
// We also overwrite `price.amount` with the line total (unit amount * credit
// quantity) so the per-row price reflects the full cost of the credit bundle
// the customer is buying (e.g. 10,000 credits @ $0.01 → $100) rather than
// the per-credit unit price.
//
// Non-credit line items are returned unchanged.
export const applyCreditProductMapping = item => {
  if (!item || item?.cartLineItemCategory !== "Credits") return item

  const unitAmount = item?.price?.amount ?? 0
  const lineQuantity = item?.quantity ?? 0

  return {
    ...item,
    creditProduct: true,
    min: item?.minPurchaseThreshold,
    max: item?.maxPurchaseThreshold,
    increment: item?.quantityMultiplier,
    price: item?.price
      ? { ...item.price, amount: unitAmount * lineQuantity }
      : item?.price,
  }
}
